import { openModal } from '@core/components/ModalStack';
import { OrderCancelModalProps } from './OrderCancelModal';

export async function openOrderCancelModal(props: OrderCancelModalProps) {
  const { OrderCancelModal } = await import('./OrderCancelModal');

  openModal(OrderCancelModal, props);
}
